import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import PromiseButton from '../../Common/PromiseButton';
import React from 'react';
import Version from '../../../types/common/Version';
import versionHelper from '../../../infrastructure/helpers/functions/common/versionHelper';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import { ReactComponent as EditIcon } from '../../Common/BootstrapIcons/edit.svg';
import { ReactComponent as DownloadIcon } from '../../Common/BootstrapIcons/download.svg';
import Spinner from '../../Common/Spinner/Spinner';
import VersionStatus from '../../../types/common/VersionStatus';

const getColumns = (
    onGetChangesClick: (identifier: string) => Promise<void>,
    onEditClick?: (x: Version) => void,
    onDownloadClick?: (identifier: string) => void,
    showSpinnerForIdentifier?: string,
    hasWriteAccess?: boolean,
    isDisabled?: boolean
): ColumnDefinition<Version>[] => {
    return [
        {
            header: 'Version',
            getContent: x => versionHelper.getDisplayName(x.identifier),
            width: '90px'
        },
        {
            header: 'Change Name',
            getContent: x => x.name,
            width: '200px',
            className: 'break-all'
        },
        {
            header: 'Change Comment',
            getContent: x => x.comment,
            className: 'break-all'
        },
        {
            header: 'Timestamp',
            getContent: x => x.timestamp,
            sortKey: 'Timestamp',
            width: '180px'
        },
        {
            header: 'Status',
            getContent: x => VersionStatus[x.status as keyof typeof VersionStatus],
        },
        {
            header: 'User',
            getContent: x => x.user
        },
        {
            header: 'Actions',
            getContent: x =>
                <div className='display-flex'>
                    {hasWriteAccess &&
                        < button disabled={isDisabled} className="custom-icon-button" onClick={() => onEditClick && onEditClick(x)}>
                            <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                        </button>
                    }
                    {
                        x.identifier === showSpinnerForIdentifier ?
                            <div className='margin-bottom-5px'>
                                <Spinner />
                            </div> :
                            <button className="custom-icon-button" onClick={() => onDownloadClick && onDownloadClick(x.identifier)}>
                                <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                            </button>
                    }
                </div>
        },
        {
            header: '',
            getContent: x => <PromiseButton className="transparent-button" enableOnErrorOnly={false} task={() => onGetChangesClick(x.identifier)} text="Changes" />,
            width: '80px'
        }
    ];
}

export default getColumns;